import {InternalAxiosRequestConfig} from "axios";
import Cookies from "js-cookie";
import {ACCESS_TOKEN, REFRESH_TOKEN} from "../constants";
import { useJWTInfo as getJwtInfo } from "../../hooks";
import {ApiRequest} from "../../api/fetcher";

let promise: Promise<any>|null = null;

const getJWT = () => {
	const access_token = Cookies.get(ACCESS_TOKEN);
	const refresh_token = Cookies.get(REFRESH_TOKEN);
	if (access_token && refresh_token) {
		const [isValid] = getJwtInfo(access_token);
		return { access_token, refresh_token, isValid }
	}
	return {}
}

const setJWT = (at: string, rt: string) => {
	Cookies.set(ACCESS_TOKEN, at);
	Cookies.set(REFRESH_TOKEN, rt);
}

const clearJWT = () => {
	Cookies.remove(ACCESS_TOKEN);
	Cookies.remove(REFRESH_TOKEN);
}

const verifyJWT = (config: InternalAxiosRequestConfig): Promise<any> => {
	const { access_token, refresh_token, isValid} = getJWT();
	if (isValid) {
		return new Promise((resolve) => {
			resolve({
				...config,
				headers: {
					...config.headers,
					Authorization: `Bearer ${access_token}`
				}
			})
		})
	} else if (access_token && refresh_token) {
		if (!promise) {
			promise = new Promise((resolve, reject) => {
				ApiRequest.create().post('/investor/refresh-token', {
					access_token, refresh_token
				}).then((res) => {
					const { access_token, refresh_token } = res.data;
					setJWT(access_token, refresh_token);
					resolve({
						...config,
						headers: {
							...config.headers,
							Authorization: `Bearer ${access_token}`
						}
					})
				}).catch((e) => {
					clearJWT();
					reject(e);
				}).finally(() => {
					promise = null;
				})
			})
		}
		return promise
	}
	return new Promise((r) => r(config))
}

export default verifyJWT;
